import React from "react";
import {Button, Grid} from "@material-ui/core";
import {MapDispatchToProps, MapStateToProps, connect} from "react-redux";
import {showApproveCaseModal, showRejectCaseModal} from "../../vendors/actions/modals";
import {NotificationBox, notifications} from "../notificationBox";
import Hidden from "@material-ui/core/Hidden";
import DescriptionBox from "../descriptionBox/descriptionBox";
import {downloadFile, isMobileBrowser} from "../../vendors/utils/common";


interface Summary {
    revision: {
        comment: string,
        created_at: string,
        Documents: []
    },
    workedHours: number
}

interface OwnProps {
    data: Summary,
}


interface ConnectStateProps {
    Modals?: any,
    Case?: any,
}

interface ConnectDispatchProps {
    showApproveCaseModal: (bool: boolean) => void;
    showRejectCaseModal: (bool: boolean) => void
}

type Props = OwnProps & ConnectStateProps & ConnectDispatchProps

const CaseSummary = (props: Props) => {
    const {data, Case} = props,
        {revision} = data,
        {CaseStatusNotifications} = notifications,
        documents = revision.Documents?.map((item: any, key: number) =>
            <a onClick={(e: any) => downloadFile(e, item.url, item.name)}
            key={key}
            href={item.url} download={item.name}>
            <p>{item.name}</p></a>
        ),
        showApproveCaseModal = () => props.showApproveCaseModal(true),
        showRejectCaseModal = () => props.showRejectCaseModal(true);

    return (
        <Grid container className='pb-4'>
            <Grid item xs={12} lg={11}>
                <DescriptionBox data={{text: revision.comment, description: 'Summary', date: revision.created_at, className: 'description-box'}}/>
                <div className="case-details-main-item case-summary-files d-flex pb-4">
                    <span className='paper-clip'/>
                    <div className="text text-files">
                        {documents?.length ? documents : 'No attached files'}
                    </div>
                </div>
                <Hidden xsDown>
                    <NotificationBox
                        severity={CaseStatusNotifications[Case.status].severity}
                        text={CaseStatusNotifications[Case.status].text}/>
                </Hidden>
                {/*<Hidden smUp>
                    {Case.status === 3 && <NotificationBox
                        severity={CaseStatusNotifications[Case.status].severity}
                        text={CaseStatusNotifications[Case.status].text}/>}
                </Hidden>*/}
            </Grid>
            {Case.status === 3 && <Grid item xs={12} lg={11}>
                <div className='d-flex justify-content-center justify-content-md-end buttons-wrapper'>
                    <Button
                        color="primary"
                        onClick={showApproveCaseModal}
                        size={isMobileBrowser() ? 'medium' : 'large'}
                        variant="contained"
                        className="mx-1 mr-4">
                        <span className="btn-wrapper--label font-size-md">Approve</span>
                    </Button>
                    <Button
                        color="default"
                        onClick={showRejectCaseModal}
                        size={isMobileBrowser() ? 'medium' : 'large'}
                        variant="outlined"
                        className="mx-1 text-black-50">
                        <span className="btn-wrapper--label">Reject</span>
                    </Button>
                </div>
            </Grid>}
        </Grid>
    )
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Modals, Case} = state;
    return {
        Modals,
        Case
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        showApproveCaseModal: (data: boolean) => dispatch(showApproveCaseModal(data)),
        showRejectCaseModal: (data: boolean) => dispatch(showRejectCaseModal(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseSummary);
